import * as React from "react";
import { useParams, useSearchParams } from "react-router";

import { ContractFamilyProjectionGate } from "@/contract-family-projection-gate";
import { getSnapshotGridCapabilities } from "@/modules/snapshots/grid/dataSource";
import { SnapshotGridCore } from "@/modules/snapshots/grid/SnapshotGridCore";

export const SnapshotGridView: React.FC = () => {
  const { collectionId = "", businessReportId = "" } = useParams<{
    collectionId: string;
    businessReportId: string;
  }>();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("contractFamilyProjection") === "true" ? "contract-family-projection" : "collection";

  return (
    <ContractFamilyProjectionGate>
      <SnapshotGridCore
        snapshotCollectionId={collectionId}
        templateId={businessReportId}
        mode={mode}
        capabilities={getSnapshotGridCapabilities(mode)}
      />
    </ContractFamilyProjectionGate>
  );
};
